module.exports = __webpack_public_path__ + "static/img/super-admin-logo.b578256e.png";